import _extends from "@babel/runtime-corejs3/helpers/extends";
import React, { forwardRef } from 'react';
import IconButton from './';
import SuccessButton from '../basic/success';

function SuccessIconButton(props) {
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    Button: SuccessButton
  }, props));
} // eslint-disable-next-line


export default /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SuccessIconButton, _extends({
    forwardedRef: ref
  }, props));
});